import React, {useContext, useEffect, useState} from "react";
import {Button, Row, Col, Modal, Radio, notification, DatePicker, message, Alert} from "antd";
import '../modals.css';
import {distributionCenterService, deliveriesService} from "../../../services";
import Spinner from "../../spinner";
import moment from "moment";
import SelectField from "../../select-field";
import FieldBlock from "../../field-block";
import localeDatePicker from "antd/lib/date-picker/locale/ru_RU";
import InputField from "../../input-field";
import DividerBlock from "../../divider-block";
import {AppContext} from "../../../contexts/app-context";
import i18n from "../../../i18n";

export default function ModalSignUpForLoadingFriendly({
                                                     isShow,
                                                     setIsShow,
                                                     orderDate,
                                                     deliveryId,
                                                     setNeedUpdate
                                                   }) {

  const appContext = useContext(AppContext);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [distCenters, setDistCenters] = useState([]);
  const [currentDistCenter, setCurrentDistCenter] = useState(null);

  const [fieldsErrors, setFieldsErrors] = useState([]);
  const [loadingTimes, setLoadingTimes] = useState(false);
  const [times, setTimes] = useState(null);


  const [timeLoading, setTimeLoading] = useState(null);


  const bigButtonStyle = {
    width: '200px',
    height: '43px',
    background: '#1CAA53',
    position: 'static',
    borderRadius: '10px'
  };

  useEffect(() => {
    if (distCenters.length === 0 && isShow) {
      distributionCenterService.getCompanies(
            true,
            false,
            null,
            null,
            true
        )
        .then((response) => {
          const distributionsCentersData = response.map((item) => {
            return {
              id: item.Id,
              name: item.Name,
            };
          });

          setDistCenters(distributionsCentersData);
          setLoading(false);
          if (distributionsCentersData.length > 0) {
            setCurrentDistCenter(distributionsCentersData[0].id);
          }

        }).catch((errMsg) => notification.error(
        {
          message: i18n.t('components.notification.titles.getCompanies2'),
          description: errMsg
        }));
    }
  }, [isShow])

  useEffect(() => {
    if (isShow && currentDistCenter !== null && orderDate !== null) {
      setError(null);
      setTimeLoading(null);
      setLoadingTimes(true);
      deliveriesService.getAvailableLoadingTime(deliveryId, currentDistCenter)
        .then((response) => {
          setTimes(response);
          setLoadingTimes(false);
        })
        .catch((error) => {
          notification.error({
            message: i18n.t('components.notification.titles.getAvailableLoadingTime'),
            description: error,
          });
          setLoadingTimes(false);
        });
    }
  }, [currentDistCenter, isShow]);

  const getFieldErrors = (nameField) => {
    return (fieldsErrors && typeof fieldsErrors[nameField] !== "undefined")
      ? fieldsErrors[nameField][0]
      : null;
  };

  const onClickSignUp = (e) => {
    e.preventDefault();

    deliveriesService.signUpLoadingTime(deliveryId, timeLoading, currentDistCenter)
      .then(
        (response) => {
          notification.success({
            message: i18n.t('components.notification.titles.signUpLoadingTime'),
            description: response.message
          })

          setNeedUpdate(true);
        }
      )
      .catch((error) => {
        notification.error({
          message: i18n.t('components.notification.titles.signUpLoadingTime'),
          description: error
        })

        setNeedUpdate(true);
      });
  }

  const isButtonNotDisabled =  currentDistCenter !== null &&
    orderDate !== null && timeLoading != null

  return (
    <Modal
      title={<div><span>{i18n.t('modals.modalSignUpForLoadingFriendly.title')}</span><div>{orderDate}</div></div>}
      cancelText={i18n.t('main.buttons.close')}
      className="modal-window"
      align={null}
      visible={isShow}
      onCancel={() => {
        setIsShow(false);
      }}
      forceRender={true}
      footer={[
        <Button htmlType="submit" key="submit" style={bigButtonStyle} type="primary" disabled={!isButtonNotDisabled}
          onClick={onClickSignUp}
        >
          {i18n.t('modals.modalSignUpForLoadingFriendly.buttons.signUp')}
        </Button>,
      ]}
    >
      <Spinner loading={loading}>
        {error !== null &&
          <Row gutter={[16, 24]} style={{marginBottom: "34px"}}>
            <Col span={24}>
              <Alert message={<span style={{fontSize: 14}}>{error}</span>} type="error" />
            </Col>
          </Row>
        }

        {distCenters.length > 0 &&
          <Row gutter={[16, 24]} style={{marginBottom: "34px"}}>
            <Col span={24}>
              <SelectField
                name="distCenters" title={i18n.t('modals.modalSignUpForLoadingFriendly.fields.distCenters.title')}
                placeholder={i18n.t('modals.modalSignUpForLoadingFriendly.fields.distCenters.placeholder')}
                getErrors={() => {
                }}
                onChange={(value) => {
                  setError(null)
                  setCurrentDistCenter(distCenters.find((item) => item.id === value).id);
                }}
                style={{width: "100%"}}
                selectedValue={currentDistCenter}
                values={distCenters}/>
            </Col>
            <Col lg={16} md={24} sm={24} xs={24}>
              <Spinner loading={loadingTimes}>
                <FieldBlock name="time" title={i18n.t('modals.modalSignUpForLoadingFriendly.fields.time.title')} getErrors={getFieldErrors}>
                  <Radio.Group
                    className="radio-group-primary" value={timeLoading} name={'timeLoading'}
                    buttonStyle={'outline'}>
                    {(times && times.length && orderDate !== null) ? times.map((item, index) => {
                      return <Radio.Button
                        key={index} value={item}
                        checked={item === timeLoading}
                        style={{margin: "5px"}}
                        onClick={() => {
                          setError(null);
                          setTimeLoading(item);
                        }}
                      >{item}</Radio.Button>
                    }) : null}
                    {(times === null || !times.length) && orderDate !== null && distCenters && distCenters.length > 0 ?
                      <span>{i18n.t('modals.modalSignUpForLoadingFriendly.fields.time.noAvailable')}</span> : null}
                  </Radio.Group>
                </FieldBlock>
              </Spinner>
            </Col>
          </Row>
        }
      </Spinner>
    </Modal>
  );
}
